import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

const state = {
  conversationListAllSearchString: null,
  activeContactId: null,
  conversationsStatusList: [],
  cannedResponseSearch: '',
  activeConversation: { unsent_message: '' },
  userPhones: [],
  activePhones: [],
  //activeContact: null,
  activeMessage: null,
  replyMessage: null,
  favoritesSelected: false,
  isEnabledSend: true,
  unsentTimeout: null,
  newMessageInputHeight: 110,
};

const store = new Vuex.Store({
  state: state,
  getters: {
    getValue: state => key => {
      return state[key];
    },
  },
  mutations: {
    setValue(state, { key, value }) {
      Vue.set(state, key, value);
    },
  },
});

export default store;
